import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "release-notes"
    }}>{`Release Notes`}</h1>
    <h2 {...{
      "id": "august-1-2023"
    }}>{`August 1, 2023`}</h2>
    <h3 {...{
      "id": "android-mobile-core-1116"
    }}>{`Android Mobile Core 1.11.6`}</h3>
    <ul>
      <li parentName="ul">{`Implemented database recovery in SQLiteDataQueue for cases where adding or removing an entry fails due to unexpected errors.`}</li>
    </ul>
    <h2 {...{
      "id": "march-29-2023"
    }}>{`March 29, 2023`}</h2>
    <h3 {...{
      "id": "android-mobile-core-1115"
    }}>{`Android Mobile Core 1.11.5`}</h3>
    <ul>
      <li parentName="ul">{`Fixed crash when initializing SDK in Android direct boot mode. `}</li>
    </ul>
    <h2 {...{
      "id": "march-2-2023"
    }}>{`March 2, 2023`}</h2>
    <h3 {...{
      "id": "ios-acpcore-297"
    }}>{`iOS ACPCore 2.9.7`}</h3>
    <ul>
      <li parentName="ul">{`Fix race conditions in StringUtils.`}</li>
    </ul>
    <h2 {...{
      "id": "january-5-2023"
    }}>{`January 5, 2023`}</h2>
    <h3 {...{
      "id": "android-lifecycle-112"
    }}>{`Android Lifecycle 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixes an issue where Lifecycle launch events may set an invalid XDM `}<inlineCode parentName="li">{`environment._dc.language`}</inlineCode>{` field when the device is set to specific locales.`}</li>
    </ul>
    <h2 {...{
      "id": "september-9-2022"
    }}>{`September 9, 2022`}</h2>
    <h3 {...{
      "id": "android-core-1114"
    }}>{`Android Core 1.11.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug that prevents bundled rules from being retrieved from the correct location.`}</li>
    </ul>
    <h2 {...{
      "id": "september-8-2022"
    }}>{`September 8, 2022`}</h2>
    <h3 {...{
      "id": "android-core-1113"
    }}>{`Android Core 1.11.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug that prevents early events from being processed correctly by the rules engine.`}</li>
      <li parentName="ul">{`Removed unnecessary `}<inlineCode parentName="li">{`AtomicBoolean`}</inlineCode>{` usage while listening to Android Activity lifecycle changes.`}</li>
    </ul>
    <h2 {...{
      "id": "august-25-2022"
    }}>{`August 25, 2022`}</h2>
    <h3 {...{
      "id": "ios-acpcore-296"
    }}>{`iOS ACPCore 2.9.6`}</h3>
    <ul>
      <li parentName="ul">{`Fix race conditions in HitQueue.`}</li>
    </ul>
    <h2 {...{
      "id": "august-18-2022"
    }}>{`August 18, 2022`}</h2>
    <h3 {...{
      "id": "android-core-1112"
    }}>{`Android Core 1.11.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for bundled rules.`}</li>
      <li parentName="ul">{`Fixed a crash that can occur while extracting data from launch intent of an Android Activity.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-132"
    }}>{`Android Identity 1.3.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash that can occur during construction of a query string of IDs.`}</li>
    </ul>
    <h2 {...{
      "id": "february-14-2022"
    }}>{`February 14, 2022`}</h2>
    <h3 {...{
      "id": "ios-core-295"
    }}>{`iOS Core 2.9.5`}</h3>
    <ul>
      <li parentName="ul">{`Updates version for bundled ACPIdentity 2.5.2 release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-252"
    }}>{`iOS Identity 2.5.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixes intermittent issue for GetUrlVariables and AppendToUrl APIs when custom Analytics identifiers are being used.`}</li>
    </ul>
    <h2 {...{
      "id": "sept-3-2021"
    }}>{`Sept 3, 2021`}</h2>
    <h3 {...{
      "id": "mobile-core-launch-extension-v2120"
    }}>{`Mobile Core Launch extension v2.1.20`}</h3>
    <ul>
      <li parentName="ul">{`New `}<inlineCode parentName="li">{`Foreground`}</inlineCode>{` and `}<inlineCode parentName="li">{`Background`}</inlineCode>{` event types to be used in rules for triggering actions based on Mobile Application Lifecycle XDM events. `}</li>
    </ul>
    <h2 {...{
      "id": "june-30-2021"
    }}>{`June 30, 2021`}</h2>
    <h3 {...{
      "id": "ios-core-294"
    }}>{`iOS Core 2.9.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a Rules Engine bug affecting strings that contain the `}<inlineCode parentName="li">{`&`}</inlineCode>{` character.`}</li>
      <li parentName="ul">{`Fixed a bug where JSON objects containing empty strings were not handled correctly.`}</li>
    </ul>
    <h2 {...{
      "id": "june-15-2022"
    }}>{`June 15, 2022`}</h2>
    <h3 {...{
      "id": "android-core-1111"
    }}>{`Android Core 1.11.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash which was caused by an exception thrown from the Android Activity class.`}</li>
    </ul>
    <h2 {...{
      "id": "april-21-2022"
    }}>{`April 21, 2022`}</h2>
    <h3 {...{
      "id": "android-core-1110"
    }}>{`Android Core 1.11.0`}</h3>
    <ul>
      <li parentName="ul">{`Internal fixes to support In-App Messaging with the AEPMessaging extension.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-131"
    }}>{`Android Identity 1.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Improved extension stability by adding additional error checks when processing sync identifier requests.`}</li>
    </ul>
    <h3 {...{
      "id": "march-31-2021"
    }}>{`March 31, 2021`}</h3>
    <h4 {...{
      "id": "lifecycle-core-107"
    }}>{`Lifecycle Core 1.0.7`}</h4>
    <ul>
      <li parentName="ul">{`No longer generate invalid values for `}<inlineCode parentName="li">{`Days Since Last Use`}</inlineCode>{`, `}<inlineCode parentName="li">{`Days Since First Use`}</inlineCode>{` and `}<inlineCode parentName="li">{`Days Since Last Upgrade`}</inlineCode>{` metrics when the time setting on the device is off.`}</li>
    </ul>
    <h3 {...{
      "id": "march-16-2021"
    }}>{`March 16, 2021`}</h3>
    <h4 {...{
      "id": "ios-core-293"
    }}>{`iOS Core 2.9.3`}</h4>
    <ul>
      <li parentName="ul">{`Fixed a Rules Engine bug affecting strings that contain regex escaping characters `}{`(`}{`one of `}<inlineCode parentName="li">{`*?+{`}</inlineCode>{`)`}{` in the following matcher types:`}
        <ul parentName="li">
          <li parentName="ul">{`Contains`}</li>
          <li parentName="ul">{`Not Contains`}</li>
          <li parentName="ul">{`Starts With`}</li>
          <li parentName="ul">{`Ends With`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "march-11-2022"
    }}>{`March 11, 2022`}</h2>
    <h3 {...{
      "id": "android-core-1101"
    }}>{`Android Core 1.10.1`}</h3>
    <ul>
      <li parentName="ul">{`Updates the timestamp format for rule token `}<inlineCode parentName="li">{`~timestampp`}</inlineCode>{`  with fractional seconds and UTC time zone. This rule token is used to set the mobile property data element "Adobe Experience Platform Timestamp".`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-111"
    }}>{`Android Lifecycle 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Lifecycle foreground and background events for Edge Network now format timestamps with fractional seconds and UTC time zone.`}</li>
    </ul>
    <h2 {...{
      "id": "february-8-2022"
    }}>{`February 8, 2022`}</h2>
    <h3 {...{
      "id": "android-identity-130"
    }}>{`Android Identity 1.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added a `}<inlineCode parentName="li">{`device_consent`}</inlineCode>{` status parameter when `}<inlineCode parentName="li">{`setAdvertisingIdentifier`}</inlineCode>{` is called after ad tracking is enabled/disabled.`}</li>
      <li parentName="ul">{`Added support to handle the MobileCore.resetIdentities() API.`}</li>
      <li parentName="ul">{`Fixes intermittent issue for GetUrlVariables and AppendToUrl APIs when custom Analytics identifiers are being used.`}</li>
      <li parentName="ul">{`Stability improvements for network connections.`}</li>
    </ul>
    <p>{`Released with sdk-core version 1.10.0`}</p>
    <h2 {...{
      "id": "february-7-2022"
    }}>{`February 7, 2022`}</h2>
    <h3 {...{
      "id": "android-core-1100"
    }}>{`Android Core 1.10.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for a new API `}<inlineCode parentName="li">{`clearUpdatedConfiguration()`}</inlineCode>{`, see Configuration API reference for more details.`}</li>
      <li parentName="ul">{`Added support for optionally capturing event history on the device.`}</li>
      <li parentName="ul">{`Added support for triggering rules engine conditions based on event history.`}</li>
      <li parentName="ul">{`Added public platform support for datastore and UI services.`}</li>
    </ul>
    <h2 {...{
      "id": "december-22-2021"
    }}>{`December 22, 2021`}</h2>
    <h3 {...{
      "id": "android-core-192"
    }}>{`Android Core 1.9.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where event number was not incremented correctly for shared states.`}</li>
      <li parentName="ul">{`Stability improvements for Configuration extension.`}</li>
      <li parentName="ul">{`Configuration now allows for empty appId to reset the previously set appId value.`}</li>
      <li parentName="ul">{`The Event Hub shares wrapper type in its shared state.`}</li>
    </ul>
    <h2 {...{
      "id": "december-15-2021"
    }}>{`December 15, 2021`}</h2>
    <h3 {...{
      "id": "android-core-191"
    }}>{`Android Core 1.9.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue that was causing duplicate query parameters in a deep link to be removed.`}</li>
    </ul>
    <h3 {...{
      "id": "android-signal-104"
    }}>{`Android Signal 1.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Bug fix to improve Signal stability.`}</li>
    </ul>
    <h2 {...{
      "id": "september-3-2021"
    }}>{`September 3, 2021`}</h2>
    <h3 {...{
      "id": "android-core-190"
    }}>{`Android Core 1.9.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for dispatch event rules consequence.`}</li>
      <li parentName="ul">{`Added getFriendlyName API for third party extensions.`}</li>
      <li parentName="ul">{`Specifies mutability for PendingIntent in the UIService in preparation for Android 12 changes.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-110"
    }}>{`Android Lifecycle 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Lifecycle extension now dispatches two new events `}<inlineCode parentName="li">{`applicationLaunch`}</inlineCode>{` and `}<inlineCode parentName="li">{`applicationClose`}</inlineCode>{` which contain Mobile Lifecycle metrics in XDM format.`}</li>
    </ul>
    <h2 {...{
      "id": "august-27-2021"
    }}>{`August 27, 2021`}</h2>
    <h3 {...{
      "id": "android-core-183"
    }}>{`Android Core 1.8.3`}</h3>
    <ul>
      <li parentName="ul">{`Updated proguard rules to fix an issue which caused some extensions to not be registered correctly when using minification.`}</li>
    </ul>
    <h2 {...{
      "id": "june-8-2021"
    }}>{`June 8, 2021`}</h2>
    <h3 {...{
      "id": "android-core-182"
    }}>{`Android Core 1.8.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug in the `}<inlineCode parentName="li">{`PersistentHitQueue`}</inlineCode>{` where hits would be retried earlier than desired in certain scenarios`}</li>
      <li parentName="ul">{`Fixed a bug where rule tokens with "&" were not handled correctly`}</li>
      <li parentName="ul">{`Minor change to how the SDK computes the operating system name`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-108"
    }}>{`Android Lifecycle 1.0.8`}</h3>
    <ul>
      <li parentName="ul">{`Minor update to ensure compatibility with the latest Core 1.8.2`}</li>
    </ul>
    <h2 {...{
      "id": "may-25-2021"
    }}>{`May 25, 2021`}</h2>
    <h3 {...{
      "id": "android-core-181"
    }}>{`Android Core 1.8.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for Event encode/decode.`}</li>
    </ul>
    <h2 {...{
      "id": "march-31-2021-1"
    }}>{`March 31, 2021`}</h2>
    <h3 {...{
      "id": "android-core-180"
    }}>{`Android Core 1.8.0`}</h3>
    <ul>
      <li parentName="ul">{`New API - Public platform services for network, data queue, device info.`}</li>
      <li parentName="ul">{`New API - `}<inlineCode parentName="li">{`MobileCore.resetIdentities()`}</inlineCode>{` - See API Reference for more information`}</li>
      <li parentName="ul">{`New API - `}<inlineCode parentName="li">{`MobileCore.dispatchEventWithResponseCallback()`}</inlineCode>{` - See API Reference for more information.`}</li>
      <li parentName="ul">{`The EventHub's shared state dictionary now uses the full name of each registered extension as its key.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-107"
    }}>{`Android Lifecycle 1.0.7`}</h3>
    <ul>
      <li parentName="ul">{`No longer generate invalid values for `}<inlineCode parentName="li">{`Days Since Last Use`}</inlineCode>{`, `}<inlineCode parentName="li">{`Days Since First Use`}</inlineCode>{` and `}<inlineCode parentName="li">{`Days Since Last Upgrade`}</inlineCode>{` metrics when the time setting on the device is off.`}</li>
    </ul>
    <h2 {...{
      "id": "march-9-2021"
    }}>{`March 9, 2021`}</h2>
    <h3 {...{
      "id": "ios-core-292"
    }}>{`iOS Core 2.9.2`}</h3>
    <ul>
      <li parentName="ul">{`Update version for bundled ACPIdentity 2.5.1 and ACPLifecycle 2.2.1 release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-251"
    }}>{`iOS Identity 2.5.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the visitor URL variables was using a TS in milliseconds instead of seconds.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-221"
    }}>{`iOS Lifecycle 2.2.1`}</h3>
    <ul>
      <li parentName="ul">{`No longer generate invalid values for `}<inlineCode parentName="li">{`Days Since Last Use`}</inlineCode>{`, `}<inlineCode parentName="li">{`Days Since First Use`}</inlineCode>{` and `}<inlineCode parentName="li">{`Days Since Last Upgrade`}</inlineCode>{` metrics when the time setting on the device is off.`}</li>
    </ul>
    <h2 {...{
      "id": "february-24-2021"
    }}>{`February 24, 2021`}</h2>
    <h3 {...{
      "id": "android-core-170"
    }}>{`Android Core 1.7.0`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash which was caused by the exception thrown from the Android okhttp library.`}</li>
      <li parentName="ul">{`Added new public APIs to set XDM shared state.`}</li>
      <li parentName="ul">{`Added a new API `}<inlineCode parentName="li">{`MobileCore.configureWithFileInAssets()`}</inlineCode>{` which allows the app to use a config file in the app's Assets folder.`}</li>
    </ul>
    <h2 {...{
      "id": "february-2-2021"
    }}>{`February 2, 2021`}</h2>
    <h3 {...{
      "id": "android-core-160"
    }}>{`Android Core 1.6.0`}</h3>
    <ul>
      <li parentName="ul">{`Added a new API `}<inlineCode parentName="li">{`MobileCore.registerEventListener`}</inlineCode>{` which can be used to register a permanent event listener.`}</li>
      <li parentName="ul">{`Fixed a bug which prevented cached configuration being loaded during app launch.`}</li>
      <li parentName="ul">{`Fixed a crash which was caused by the exception thrown from the Android `}<inlineCode parentName="li">{`okhttp`}</inlineCode>{` library.`}</li>
    </ul>
    <h2 {...{
      "id": "february-11-2021"
    }}>{`February 11, 2021`}</h2>
    <h3 {...{
      "id": "ios-core-291"
    }}>{`iOS Core 2.9.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash which happened in `}<inlineCode parentName="li">{`AdobeMarketingMobile::StringUtils`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "december-18-2020"
    }}>{`December 18, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-290-ios-identity-250-ios-lifecycle-220-ios-signal-220"
    }}>{`iOS Core 2.9.0, iOS Identity 2.5.0, iOS Lifecycle 2.2.0, iOS Signal 2.2.0`}</h3>
    <ul>
      <li parentName="ul">{`The AEP SDKs are now distributed using XCFrameworks in order to support hardware with the new Apple M1 architecture while maintaining support for existing Intel architecture.`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`IMPORTANT`}</strong>{`: Upgrading to XCFrameworks distribution requires Xcode 12.0 or newer`}</li>
          <li parentName="ul"><strong parentName="li">{`IMPORTANT`}</strong>{`: If using Cocoapods, upgrading to the XCFrameworks distribution requires Cocoapods 1.10.0 or newer`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "december-3-2020"
    }}>{`December 3, 2020`}</h2>
    <h3 {...{
      "id": "android-identity-122"
    }}>{`Android Identity 1.2.2`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Fix issue where push identifier had incorrect value in Identity shared state when `}<inlineCode parentName="p">{`setPushIdentifer`}</inlineCode>{` was not called on each launch.`}</p>
        <p parentName="li">{`Released with sdk-core version 1.5.8`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "december-2-2020"
    }}>{`December 2, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-282"
    }}>{`iOS Core 2.8.2`}</h3>
    <ul>
      <li parentName="ul">{`Update version for bundled ACPIdentity 2.4.1 release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-241"
    }}>{`iOS Identity 2.4.1`}</h3>
    <ul>
      <li parentName="ul">{`Fix issue where push identifier had incorrect value in Identity shared state when `}<inlineCode parentName="li">{`setPushIdentifer`}</inlineCode>{` was not called on each launch.`}</li>
    </ul>
    <h2 {...{
      "id": "november-18-2020"
    }}>{`November 18, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-281"
    }}>{`iOS Core 2.8.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a memory alignment issue that caused crashes in iOS 10.x.`}</li>
    </ul>
    <h2 {...{
      "id": "november-4-2020"
    }}>{`November 4, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-280"
    }}>{`iOS Core 2.8.0`}</h3>
    <ul>
      <li parentName="ul">{`Update version for bundled ACPIdentity 2.4.0 release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-240"
    }}>{`iOS Identity 2.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Added a `}<inlineCode parentName="li">{`device_consent`}</inlineCode>{` status parameter when `}<inlineCode parentName="li">{`setAdvertisingIdentifier`}</inlineCode>{` is called after ad tracking is enabled/disabled.`}</li>
      <li parentName="ul">{`The default Identity Server URL of `}<inlineCode parentName="li">{`dpm.demdex.com`}</inlineCode>{` is used if the SDK configuration parameter `}<inlineCode parentName="li">{`experienceCloud.server`}</inlineCode>{` is either missing or an empty string.`}</li>
    </ul>
    <h2 {...{
      "id": "october-21-2020"
    }}>{`October 21, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-276"
    }}>{`iOS Core 2.7.6`}</h3>
    <ul>
      <li parentName="ul">{`Fixed several crashes that were happening during app shutdown.`}</li>
    </ul>
    <h2 {...{
      "id": "september-22-2020"
    }}>{`September 22, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-275"
    }}>{`iOS Core 2.7.5`}</h3>
    <ul>
      <li parentName="ul">{`Fixes an issue where the EventHub could be blocked by synchronous network calls returning recoverable errors.`}</li>
    </ul>
    <h2 {...{
      "id": "september-10-2020"
    }}>{`September 10, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-274"
    }}>{`iOS Core 2.7.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an intermitted issue where third party extensions may experience crashes after unregistration when using the `}<inlineCode parentName="li">{`ACPExtensionAPI`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-212"
    }}>{`iOS Lifecycle 2.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Added previous application Id and OS version info to lifecycle event data.`}</li>
    </ul>
    <h2 {...{
      "id": "september-9-2020"
    }}>{`September 9, 2020`}</h2>
    <h3 {...{
      "id": "android-core-157"
    }}>{`Android Core 1.5.7`}</h3>
    <ul>
      <li parentName="ul">{`Fixed the issue where it may fail to save caches when `}<inlineCode parentName="li">{`Etag`}</inlineCode>{` contains special characters.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-121"
    }}>{`Android Identity 1.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Identity shared state now gets updated in current session on server response changes for blob or locationHint.`}</li>
      <li parentName="ul">{`In order to improve the Analytics push tracking reports, the push notification preferences `}{`(`}<inlineCode parentName="li">{`a.push.optin`}</inlineCode>{`)`}{` are now forwarded to Analytics whenever the value passed to `}<inlineCode parentName="li">{`setPushIdentifier`}</inlineCode>{` is different than the previous time it was called.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-106"
    }}>{`Android Lifecycle 1.0.6`}</h3>
    <ul>
      <li parentName="ul">{`Added previous application Id and OS version info to lifecycle event data.`}</li>
    </ul>
    <h2 {...{
      "id": "august-10-2020"
    }}>{`August 10, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-272-released-with-acpcore-version-273-on-cocoapods"
    }}>{`iOS Core 2.7.2 `}{`(`}{`Released with ACPCore version 2.7.3 on Cocoapods`}{`)`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash happening on `}<inlineCode parentName="li">{`AdobeMarketingMobile::RulesEngine::ProcessEventForRules()`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Fixed an issue where null values in rules consequences were not respected.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-232"
    }}>{`iOS Identity 2.3.2`}</h3>
    <ul>
      <li parentName="ul">{`Identity shared state now gets updated in current session on server response changes for blob or locationHint.`}</li>
      <li parentName="ul">{`In order to improve the Analytics push tracking reports, the push notification preferences `}{`(`}<inlineCode parentName="li">{`a.push.optin`}</inlineCode>{`)`}{` are now forwarded to Analytics whenever the value passed to `}<inlineCode parentName="li">{`setPushIdentifier`}</inlineCode>{` is different than the previous time it was called.`}</li>
      <li parentName="ul">{`Improved safety checks for the Identity APIs with completion handler.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-211"
    }}>{`iOS Lifecycle 2.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Session start time is now added to the shared state of Lifecycle extension.`}</li>
    </ul>
    <h2 {...{
      "id": "july-31-2020"
    }}>{`July 31, 2020`}</h2>
    <h3 {...{
      "id": "android-core-156"
    }}>{`Android Core 1.5.6`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where null values in rules consequences was not respected.`}</li>
      <li parentName="ul">{`Some internal fixes.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-105"
    }}>{`Android Lifecycle 1.0.5`}</h3>
    <ul>
      <li parentName="ul">{`Session start time is now added to the shared state of Lifecycle extension`}</li>
    </ul>
    <h2 {...{
      "id": "july-16-2020"
    }}>{`July 16, 2020`}</h2>
    <h3 {...{
      "id": "android-core-155"
    }}>{`Android Core 1.5.5`}</h3>
    <ul>
      <li parentName="ul">{`Updated the wrapper type strings used by SDK plugins.`}</li>
      <li parentName="ul">{`Added support for the token `}<inlineCode parentName="li">{`~timestampp`}</inlineCode>{` which complies with the Adobe Experience Platform Edge Network.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-271"
    }}>{`iOS Core 2.7.1`}</h3>
    <ul>
      <li parentName="ul">{`Updated the wrapper type strings used by SDK plugins.`}</li>
      <li parentName="ul">{`Added support for the token `}<inlineCode parentName="li">{`~timestampp`}</inlineCode>{` which complies with the Adobe Experience Platform Edge Network.`}</li>
      <li parentName="ul">{`Another attampt to fix the crash on `}<inlineCode parentName="li">{`std::__1::system_error: mutex lock failed: Invalid argument`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Released with ACPCore version 2.7.2 on Cocoapods`}</p>
    <h2 {...{
      "id": "june-26-2020"
    }}>{`June 26, 2020`}</h2>
    <h3 {...{
      "id": "ios-identity-231"
    }}>{`iOS Identity 2.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an intermittent bug where Identity data was not loading at SDK initialization time.`}</li>
    </ul>
    <p>{`Released with ACPCore version 2.7.1 on Cocoapods`}</p>
    <h2 {...{
      "id": "june-17-2020"
    }}>{`June 17, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-270"
    }}>{`iOS Core 2.7.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.7.0 onwards, binaries are built with Xcode 11.0`}</li>
      <li parentName="ul">{`Fixed a crash which happened in AdobeMarketingMobile::ModuleEventListenerBase`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-210"
    }}>{`iOS Lifecycle 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.1.0 onwards, binaries are built with Xcode 11.0`}</li>
    </ul>
    <h3 {...{
      "id": "ios-signal-210"
    }}>{`iOS Signal 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.1.0 onwards, binaries are built with Xcode 11.0`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-230"
    }}>{`iOS Identity 2.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.3.0 onwards, binaries are built with Xcode 11.0`}</li>
    </ul>
    <h2 {...{
      "id": "may-28-2020"
    }}>{`May 28, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-154"
    }}>{`Android Core 1.5.4`}</h3>
    <ul>
      <li parentName="ul">{`Added the capability for rules engine to reprocess the events that are dispatched before rules are loaded.`}</li>
      <li parentName="ul">{`Fixed a bug where the shared state of event hub was not properly created.`}</li>
      <li parentName="ul">{`Fixed a security issue.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-262"
    }}>{`iOS Core 2.6.2`}</h3>
    <ul>
      <li parentName="ul">{`Added the capability for rules engine to reprocess the events that are dispatched before rules are loaded.`}</li>
      <li parentName="ul">{`Fixed the import statement in `}<inlineCode parentName="li">{`ACPNetworkServiceOverrider.h`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "april-21-2020"
    }}>{`April 21, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-153"
    }}>{`Android Core 1.5.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a performance issue where the initialization of SDK extensions could block the main thread for a while.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-161"
    }}>{`iOS Core 1.6.1`}</h3>
    <ul>
      <li parentName="ul">{`Added an internal enum for Cordova support.`}</li>
    </ul>
    <h2 {...{
      "id": "april-9-2020"
    }}>{`April 9, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-152"
    }}>{`Android Core 1.5.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed several security issues.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-103"
    }}>{`Android Lifecycle 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the `}<inlineCode parentName="li">{`Resolution`}</inlineCode>{` was captured in non-English numerals.`}</li>
    </ul>
    <h2 {...{
      "id": "april-2-2020"
    }}>{`April 2, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-260"
    }}>{`iOS Core 2.6.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for overriding internal network stack with customer-provided implementation. For more information, see `}<a parentName="li" {...{
          "href": "../mobile-core/platform-services/index.md#ios"
        }}>{`Override network stack`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "march-16-2020"
    }}>{`March 16, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-251"
    }}>{`iOS Core 2.5.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash which happened in `}<inlineCode parentName="li">{`ADBJsonType::Get`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Fixed a crash which happened in `}<inlineCode parentName="li">{`EventHubInner::CreateOrUpdateSharedStateCommon`}</inlineCode>{`, the crash was introduced on the version 2.5.0.`}</li>
      <li parentName="ul">{`Fixed an internal issue where the SDK failed to create a Json array if it contains empty items.`}</li>
      <li parentName="ul">{`Improved log messages.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-221"
    }}>{`iOS Identity 2.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where all Identity APIs with callbacks were subject to a timeout. Only Identity APIs which use a completionHandler callback are subject to a timeout.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-signal-204"
    }}>{`iOS Signal 2.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Improved log messages.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-204"
    }}>{`iOS Lifecycle 2.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Improved log messages.`}</li>
    </ul>
    <h2 {...{
      "id": "february-27-2020"
    }}>{`February 27, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-151"
    }}>{`Android Core 1.5.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where AppID used non-arabic numbers as app versions.`}</li>
      <li parentName="ul">{`Fixed a bug where app version was not included in AppID on Android 9 or above devices.`}</li>
      <li parentName="ul">{`Added Wrapper Type for Flutter.`}</li>
    </ul>
    <h3 {...{
      "id": "android-signal-103"
    }}>{`Android Signal 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Logging improvement`}</li>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-103-1"
    }}>{`Android Lifecycle 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Logging improvement`}</li>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
    </ul>
    <h2 {...{
      "id": "february-19-2020"
    }}>{`February 19, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-250"
    }}>{`iOS Core 2.5.0`}</h3>
    <ul>
      <li parentName="ul">{`Mobile Core now shares the list of enabled extensions and their meta data through shared state.`}</li>
      <li parentName="ul">{`Added Wrapper Type for Flutter.`}</li>
      <li parentName="ul">{`Exposed eventNumber and eventTimestamp in ACPExtensionEvent class.`}</li>
      <li parentName="ul">{`Added the following API to support the completion handler with an nullable `}<inlineCode parentName="li">{`NSError`}</inlineCode>{` object:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`getPrivacyStatusWithCompletionHandler`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getSdkIdentitiesWithCompletionHandler`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "ios-identity-220"
    }}>{`iOS Identity 2.2.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added the following APIs to support the completionHandler callback that is available in iOS ACPCore version 2.5.0:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`appendToURL:withCompletionHandler`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getUrlVariablesWithCompletionHandler`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getIdentifiersWithCompletionHandler`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getExperienceCloudIdWithCompletionHandler`}</inlineCode></li>
        </ul>
        <p parentName="li">{`When the `}<inlineCode parentName="p">{`completionHandler`}</inlineCode>{` is used, and you are retrieving the Mobile SDK values, the timeout value is 500ms; if the operation times out or is not successful, an `}<inlineCode parentName="p">{`NSError`}</inlineCode>{` is returned.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "february-4-2020"
    }}>{`February 4, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-150"
    }}>{`Android Core 1.5.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Fixed a cursor leak.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Mobile Core now shares the list of enabled extensions and their meta data through shared state.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Fixed an issue where the advertising identifier was duplicated in the response to the `}<inlineCode parentName="p">{`MobileCore.getSDKIdentifiers`}</inlineCode>{` API.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added support for overriding internal network stack with customer-provided code.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added a new interface with failure callback, `}<inlineCode parentName="p">{`AdobeCallbackWithError`}</inlineCode>{`, which can be used with the `}<inlineCode parentName="p">{`MobileCore.getPrivacyStatus`}</inlineCode>{`, `}<inlineCode parentName="p">{`MobileCore.getSdkIdentities`}</inlineCode>{` methods.`}</p>
        <p parentName="li">{`We plan to gradually add the ability to enable failure callback to the other extensions.`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "android-identity-120"
    }}>{`Android Identity 1.2.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Added support for the optional `}<inlineCode parentName="p">{`AdobeCallbackWithError`}</inlineCode>{` callback that is available in Android Core version 1.5.0 on the following APIs:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`appendVisitorInfoForURL`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getUrlVariables`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getIdentifiers`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getExperienceCloudId`}</inlineCode></li>
        </ul>
        <p parentName="li">{`When the `}<inlineCode parentName="p">{`AdobeCallbackWithError`}</inlineCode>{` is used, and you are retrieving the Mobile SDK values, the timeout value is 500ms; if the operation times out or is not successful, an `}<inlineCode parentName="p">{`AdobeError`}</inlineCode>{` is returned.`}</p>
      </li>
    </ul>
    <p>{`Released with sdk-core version 1.5.0.`}</p>
    <h2 {...{
      "id": "january-27-2020"
    }}>{`January 27, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <p><strong parentName="p">{`iOS Core 2.4.0`}</strong></p>
    <ul>
      <li parentName="ul">{`Added a new property, `}<inlineCode parentName="li">{`eventUniqueIdentifier`}</inlineCode>{`, to the `}<inlineCode parentName="li">{`ACPExtensionEvent`}</inlineCode>{` class.`}</li>
      <li parentName="ul">{`Fixed an issue where the advertising identifier was duplicated in the response of the `}<inlineCode parentName="li">{`getSDKIdentifiers`}</inlineCode>{` API.`}</li>
      <li parentName="ul">{`Fixed an issue where the SDK was trying to download the rules multipile times immediately after app launch.`}</li>
      <li parentName="ul">{`Fixed a crash on `}<inlineCode parentName="li">{`std::__1::system_error: mutex lock failed: Invalid argument`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Fixed a bug where the iOS fullscreen message was unable to load cached images.`}</li>
    </ul>
    <h2 {...{
      "id": "november-15-2019"
    }}>{`November 15, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-identity-213"
    }}>{`iOS Identity 2.1.3`}</h3>
    <ul>
      <li parentName="ul">{`Synced custom and advertising identifiers with nil or empty values are now cleared from Identity shared state and local storage. They are also not synced with the Experience Cloud ID `}{`(`}{`ECID`}{`)`}{` Service.`}</li>
      <li parentName="ul">{`Fixed a threading issue where the Experience Cloud ID `}{`(`}{`ECID`}{`)`}{` Service response was handled on an incorrect thread potentially causing a memory corruption crash.`}</li>
    </ul>
    <p>{`These changes were released as part of ACPCore CocoaPod v2.3.6.`}</p>
    <h2 {...{
      "id": "october-25-2019"
    }}>{`October 25, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-145"
    }}>{`Android Core 1.4.5`}</h3>
    <ul>
      <li parentName="ul">{`Added support for attach data rules consequence.`}</li>
      <li parentName="ul">{`Added support for a boolean-type comparison for the Exist or Not Exist rules condition.`}</li>
      <li parentName="ul">{`Fixed a bug where the Exist and Not Exist rules condition might not work for a List or Map type value.`}</li>
      <li parentName="ul">{`Fixed a bug that, when fetching the remote config from Launch, might cause a crash on some Android devices.`}</li>
      <li parentName="ul">{`Fixed a bug that, when the data URL of an activity did not contain valid schema, might cause a crash.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-112"
    }}>{`Android Identity 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the default Experience Cloud Server hostname is now used when no value is configured in the SDK.`}</li>
      <li parentName="ul">{`Fixed a bug where multiple custom identifiers with same idType value were synced with the Visitor ID Service.`}</li>
      <li parentName="ul">{`Custom visitor identifiers can now be cleared from the SDK by providing a null/empty identifier value for a previously synced idType.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-235"
    }}>{`iOS Core 2.3.5`}</h3>
    <ul>
      <li parentName="ul">{`Added support for attach data rules consequence.`}</li>
      <li parentName="ul">{`Added support for a boolean-type comparison for the Exist or Not Exist rules condition.`}</li>
    </ul>
    <h2 {...{
      "id": "october-4-2019"
    }}>{`October 4, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-234"
    }}>{`iOS Core 2.3.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash that might have happened during app shutdown..    `}</li>
      <li parentName="ul">{`Fixed a bug where, when the SDK is being used in multiple threads, the SDK might not function under a race condition..    `}</li>
      <li parentName="ul">{`Fixed a bug where the downloaded rules zip file might not be decompressed.    `}</li>
      <li parentName="ul">{`Fixed a bug where the getSdkIdentities API used wrong key names for the Push ID and IDFA.    `}</li>
      <li parentName="ul">{`Removed the usage of UIWebView.    `}</li>
      <li parentName="ul">{`Extension listeners with null/empty type or source is now invalid and will not be registered.    `}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-212"
    }}>{`iOS Identity 2.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where the push identifier is not contained in the Identity shared state on bootup.    `}</li>
      <li parentName="ul">{`Fixed an issue where appendToUrl uses the incorrect query delimiter when the source URL contains a question mark in its fragment identifier component.`}</li>
    </ul>
    <h2 {...{
      "id": "september-17-2019"
    }}>{`September 17, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-144"
    }}>{`Android Core 1.4.4`}</h3>
    <ul>
      <li parentName="ul">{`Starting in API level 16, notifications now support BigTextStyle.`}
        <ul parentName="li">
          <li parentName="ul">{`This enables long notifications to be displayed without being truncated.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Fixed the locale string in the HTTP User-Agent to follow the BCP 47 specification.`}</li>
    </ul>
    <h2 {...{
      "id": "september-9-2019"
    }}>{`September 9, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-identity-111"
    }}>{`Android Identity 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Custom identifiers with null or empty IDs are ignored when calling the syncIdentifier or syncIdentifiers APIs because the Visitor ID Service does not support these identifiers.`}</li>
      <li parentName="ul">{`The syncIdentifiers API call is ignored when there is an empty Map.`}</li>
      <li parentName="ul">{`The duplicate advertising identifier value is removed from the Identity-shared state when MobileCore.setAdvertisingIdentifier is called with a new value.`}</li>
      <li parentName="ul">{`The global.ssl configuration settings are ignored, and SSL is enabled by default.`}</li>
      <li parentName="ul">{`Fixed an issue where appendVisitorInfoForURL uses the wrong query delimiter when the source URL contains a question mark in its fragment identifier component.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      